<p-toast></p-toast>
<header>
    <h3>{{'notifications' |  translate}}</h3>
</header>
<div class="ml-5 md:px-5 md:ml-0">
    <div class="flex justify-content-between mb-2">
        <h5 class="my-1 mr-2">
            {{'notification_new_follower' |translate}}
        </h5>
        <div class="my-auto">
            <p-inputSwitch (onChange)="handleChange($event, notificationType.Following, newFollower)" class="align-self-center" [(ngModel)]="newFollowerSwitch"></p-inputSwitch>
        </div>
    </div>
    <div class="flex justify-content-between mb-2">
        <h5 class="my-1 mr-2">
            {{'notification_comment_own_deal' |translate}}
        </h5>
        <div class="my-auto">
            <p-inputSwitch (onChange)="handleChange($event, notificationType.CommentOnDeal, commentOwnDeal)" class="align-self-center" [(ngModel)]="commentOwnDealSwitch"></p-inputSwitch>
        </div>
    </div>
    <div class="flex justify-content-between mb-2">
        <h5 class="my-1 mr-2">
            {{'notification_comment_reply' |translate}}
        </h5>
        <div class="my-auto">
            <p-inputSwitch (onChange)="handleChange($event, notificationType.ReplyOnComment, commentReply)" class="align-self-center" [(ngModel)]="commentReplySwitch"></p-inputSwitch>
        </div>
    </div>
</div>
<header>
    <h3>{{'filters' |  translate}}</h3>
</header>
<app-filters-list></app-filters-list>
